import { ChangeDetectionStrategy, Component, output } from '@angular/core'
import { ButtonModule } from 'primeng/button'

@Component({
    selector: 'app-welcome',
    imports: [ButtonModule],
    templateUrl: './welcome.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Welcome {
    login = output<void>()
}
